import React from 'react';
import {
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { EventCategory } from '../../../store/event/types';
import useStyles from './EventCategory.style';

type Props = {
  category: EventCategory,
  categoryIds: string[],
  /* eslint-disable no-unused-vars */
  handleChange: (categoryId: string) => void
}

const EventCategoryCheckbox = ({ category, categoryIds, handleChange }: Props) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      className={classes.root}
      control={(
        <Checkbox
          checked={categoryIds.includes(category.id)}
          onChange={() => handleChange(category.id)}
          name={category.name}
          color="primary"
        />
      )}
      label={category.name}
    />
  );
};

export default EventCategoryCheckbox;
